export function utm() {
  return {
    utm_source:
      getCookie("_mkto_source") === "undefined"
        ? "NULL"
        : getCookie("_mkto_source"),
    utm_campaign:
      getCookie("_mkto_utm_campaign") === "undefined"
        ? "NULL"
        : getCookie("_mkto_utm_campaign"),
    utm_medium:
      getCookie("_mkto_medium") === "undefined"
        ? "NULL"
        : getCookie("_mkto_medium"),
    utm_term:
      getCookie("_mkto_utm_term") === "undefined"
        ? "NULL"
        : getCookie("_mkto_utm_term"),
    utm_content:
      getCookie("_mkto_utm_content") === "undefined"
        ? "NULL"
        : getCookie("_mkto_utm_content"),
    gclid__c: getCookie("gclid") === "undefined" ? "NULL" : getCookie("gclid"),
  };
}

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie =
    cname + "=" + JSON.stringify(cvalue) + ";" + expires + ";path=/";
}

export function getUrlParam(name, url) {
  var parameters = new RegExp("[?&]" + name + "=([^&#]*)").exec(url);
  return parameters ? decodeURI(parameters[1]) : null;
}
